import { ReviewsList } from 'components/reviews/ReviewsList/ReviewsList'
import { useParams } from 'react-router-dom'

export const SellerReviews: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <ReviewsList sellerId={id as string} />
}
